var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlugNotconnected({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3276_1098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 16L16 20",
    stroke: "#E00000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00006 12L12.0001 17L10.5001 18.5C10.1737 18.8371 9.78356 19.1059 9.35231 19.2907C8.92106 19.4755 8.45734 19.5727 7.98817 19.5765C7.519 19.5803 7.05376 19.4907 6.61957 19.3129C6.18537 19.1351 5.7909 18.8727 5.45913 18.5409C5.12737 18.2092 4.86495 17.8147 4.68716 17.3805C4.50937 16.9463 4.41977 16.4811 4.42358 16.0119C4.42739 15.5427 4.52453 15.079 4.70934 14.6477C4.89416 14.2165 5.16295 13.8263 5.50006 13.5L7.00006 12Z",
    stroke: "#E00000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 12L12 7L13.5 5.5C13.8263 5.16289 14.2165 4.8941 14.6477 4.70928C15.079 4.52447 15.5427 4.42733 16.0119 4.42352C16.4811 4.41971 16.9463 4.50931 17.3805 4.6871C17.8147 4.86489 18.2092 5.12731 18.5409 5.45907C18.8727 5.79084 19.1351 6.18531 19.3129 6.6195C19.4907 7.0537 19.5803 7.51894 19.5765 7.98811C19.5727 8.45728 19.4755 8.921 19.2907 9.35225C19.1059 9.7835 18.8371 10.1737 18.5 10.5L17 12Z",
    stroke: "#E00000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 21L5.5 18.5",
    stroke: "#E00000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 5.5L21 3",
    stroke: "#E00000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11L8 13",
    stroke: "#E00000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 14L11 16",
    stroke: "#E00000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16L20 20",
    stroke: "#E00000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3276_1098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugNotconnected);
export default __webpack_public_path__ + "static/media/plug-notconnected.66c5f7d7508ce89a0301de55baef671c.svg";
export { ForwardRef as ReactComponent };